<template>
  <div class="flex grow justify-center">
    <CollapsibleView
      :item="item"
      :count="count"
      :filter="filter"
      :fetchingStatus="fetchingStatus"
      @show:detail="(task) => handleShowDetail(task)"
      @update:count="count = $event"
      @update:fetchingStatus="handleUpdateFetchingStatus"
    >
      <template
        v-slot:state
        v-if="count !== null || fetchingStatus === 'error'"
      >
        <State
          :type="state.type"
          :title="state.title"
          :text="state.text"
          :button="state.button"
          :action="state.action"
          @click:button="handleStateEmit(state.emit)"
        />
      </template>
    </CollapsibleView>
    <Show
      v-if="detail"
      :withBackdropButton="withBackdropButton"
      :task="detail"
      @close="detail = null"
    />
  </div>
</template>

<script setup>
import { computed, inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import route from "ziggy-js";
import axios from "axios";
import CollapsibleView from "@/SharedComponents/Passport/Steps/Tasks/Partials/CollapsibleView.vue";
import { State } from "@/SharedComponents/State";
import { default as Show } from "@/Pages/Tasks/Details/TaskDetails.vue";

// Define Props
defineProps({
  item: { type: Object, required: true },
  filter: { type: Object, required: true },
  building: { type: Object, required: true },
  count: { type: [Number, null], required: true },
  withBackdropButton: { type: Boolean, default: false },
});

// Emitter
const emitter = inject("emitter");

// Refs
const fetchingStatus = ref("loading");
const count = ref(null);
const detail = ref(null);

// Emits
const emit = defineEmits([
  "show:detail",
  "update:count",
  "update:fetchingStatus",
  "modify:count",
  "add:task",
  "reset",
]);

// Translations
const { t } = useI18n();

// Computed props
const state = computed(() => {
  let type = "Tasks";
  let title = t("components.state.no_tasks.title");
  let text = t("components.state.no_tasks.text");
  let button = null;
  let emit = null;
  let action = null;

  if (fetchingStatus.value === "error") {
    type = "Error";
    title = t("components.state.error.title");
    text = t("components.state.error.text");
    button = t("components.state.error.button");
    emit = "reload";
    action = "reload";
  }

  return {
    type: type,
    title: title,
    text: text,
    button: button,
    emit: emit,
    action: action,
  };
});

// Functions
const handleStateEmit = (value) => {
  emit(value);
};

const handleUpdateFetchingStatus = (value) => {
  fetchingStatus.value = value;
};

const handleShowDetail = (task) => {
  const url = route("api.tasks.show", [task]);
  axios.post(url).then((response) => {
    detail.value = response.data.data;
  });
};

emitter.on("reload-task-details", (task) => {
  handleShowDetail(task);
});
</script>
